import { PropsWithChildren } from 'react'
import { useGetApplicationPageProps } from '../../../hooks/useGetApplicationPageProps'
import { get } from 'lodash'

type SpecificFieldProps = PropsWithChildren<{
  field: string
  forceEnabled?: boolean
}>

export function SpecificField(props: SpecificFieldProps) {
  const { applicationPageProps } = useGetApplicationPageProps()
  const enabled = get(applicationPageProps, `specificFields.${props.field}.enabled`)

  if (!enabled && !props.forceEnabled) {
    return null
  }

  return <>{props.children}</>
}
